export const STATUS = {
  open: ["مفتوحة", "bg-sky-100 text-sky-800"],
  escalated: ["مُصعّدة", "bg-amber-100 text-amber-800"],
  returned: ["مُرجعة للاستعلام", "bg-rose-100 text-rose-800"],
  closed: ["مقفلة", "bg-slate-200 text-slate-700"],
};
export const PRIO = { high: ["عالية", "text-red-600"], medium: ["متوسطة", "text-amber-600"], low: ["منخفضة", "text-slate-500"] };
export const RETURN_REASONS = ["استعلام", "تغيير", "إضافة"];
export const PARTY_ROLES = ["المخالف", "الشاكي", "المشكو في حقه", "شاهد", "متضرر", "خبير / مقيّم", "طرف خارجي"];

export const fmt = (at) => {
  if (!at) return "";
  try { return new Date(at).toLocaleString("ar-SA-u-nu-latn-ca-gregory", { dateStyle: "medium", timeStyle: "short" }); } catch { return at; }
};

export const waLink = (phone, text) => {
  let p = String(phone || "").replace(/\D/g, "");
  if (p.startsWith("05")) p = `966${p.slice(1)}`;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
};

export const errMsg = (e, d = "تعذّر تنفيذ العملية") => e?.response?.data?.detail || d;
